import { createAction } from 'redux-act';

export const setPointsTiers = createAction('ui/SET_POINTS_TIERS');
export const clearPointsTiers = createAction('ui/CLEAR_POINTS_TIERS');
